import { Link, Typography } from '@mui/material'
import React from 'react'

export type FilterCrumb = { label: string; onClick?: () => void }

/** The path to a filter step; every crumb but the current one that can be returned to is a link. */
const FilterBreadcrumbs: React.FC<{ crumbs: FilterCrumb[] }> = ({ crumbs }) => (
  <Typography variant="body2" color="text.secondary">
    {crumbs.map((crumb, index) => {
      const isCurrent = index === crumbs.length - 1
      return (
        <React.Fragment key={index}>
          {index > 0 && ' / '}
          {crumb.onClick && !isCurrent ? (
            <Link component="button" variant="body2" color="inherit" onClick={crumb.onClick}>
              {crumb.label}
            </Link>
          ) : (
            crumb.label
          )}
        </React.Fragment>
      )
    })}
  </Typography>
)

export default FilterBreadcrumbs
